import axios from 'axios';
import {
    IRequestPointProviderGoal,
    IRequestPointSettings,
    IRequestTypePoint,
} from '../../Models/RequestPointSettings/IRequestPointSettings';
import { apiString as api } from '../../utils/constants';

interface RequestPointProviderGoalResponse {
    ProviderId: string;
    ProviderName: string;
    Goal: number;
}

interface RequestTypePointResponse {
    RequestTypeId: string;
    RequestType: string;
    Points: number;
}

interface RequestPointSettingsResponse {
    GlobalDailyGoal: number;
    ProviderGoals: RequestPointProviderGoalResponse[];
    RequestPoints: RequestTypePointResponse[];
    UpdatedOn?: string | null;
    UpdatedBy?: string | null;
}

const endpoint = `${api}/request-point-settings`;

const mapRequestPointSettings = (settings: RequestPointSettingsResponse): IRequestPointSettings => ({
    globalDailyGoal: settings.GlobalDailyGoal,
    providerGoals: (settings.ProviderGoals || []).map(
        (goal): IRequestPointProviderGoal => ({
            providerId: goal.ProviderId,
            providerName: goal.ProviderName,
            goal: goal.Goal,
        })
    ),
    requestPoints: (settings.RequestPoints || []).map(
        (point): IRequestTypePoint => ({
            requestTypeId: point.RequestTypeId,
            requestType: point.RequestType,
            points: point.Points,
        })
    ),
    updatedOn: settings.UpdatedOn,
    updatedBy: settings.UpdatedBy,
});

const mapRequestPointSettingsRequest = (settings: IRequestPointSettings): RequestPointSettingsResponse => ({
    GlobalDailyGoal: settings.globalDailyGoal,
    ProviderGoals: settings.providerGoals.map((goal) => ({
        ProviderId: goal.providerId,
        ProviderName: goal.providerName,
        Goal: goal.goal,
    })),
    RequestPoints: settings.requestPoints.map((point) => ({
        RequestTypeId: point.requestTypeId,
        RequestType: point.requestType,
        Points: point.points,
    })),
    UpdatedOn: settings.updatedOn,
    UpdatedBy: settings.updatedBy,
});

export const getRequestPointSettings = async (): Promise<IRequestPointSettings> => {
    const response = await axios.get<RequestPointSettingsResponse>(endpoint);
    return mapRequestPointSettings(response.data);
};

export const saveRequestPointSettings = async (settings: IRequestPointSettings): Promise<IRequestPointSettings> => {
    const response = await axios.put<RequestPointSettingsResponse>(
        endpoint,
        mapRequestPointSettingsRequest(settings)
    );

    return mapRequestPointSettings(response.data);
};

export const resetRequestPointSettings = async (): Promise<IRequestPointSettings> => {
    const response = await axios.post<RequestPointSettingsResponse>(`${endpoint}/reset`);
    return mapRequestPointSettings(response.data);
};